module.exports = __webpack_public_path__ + "img/0-md.c741af24.jpg";